import type { TActNavInfoState } from 'hooks/useScrollToWithNavigationInfo';
import { useTimeout } from 'hooks/useTimeout';

import type React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrolledToActId = (setIsExpanded?: (value: React.SetStateAction<boolean>) => void) => {
    const { state } = useLocation();
    const { actNavInfo } = (state || {}) as TActNavInfoState;
    const { actId, allActIds } = actNavInfo || {};

    const [scrolledToActId, setScrolledToActId] = useState<number | undefined>();
    const [scrolledToActIdsArr, setScrolledToActIdsArr] = useState<number[] | undefined>();

    useEffect(() => {
        if (Array.isArray(allActIds)) {
            setScrolledToActIdsArr(allActIds);
        } else if (actId) {
            setIsExpanded?.(true);
            setScrolledToActId(actId);
        }
    }, [actId, allActIds, setIsExpanded]);

    const resetStates = useCallback(() => {
        setScrolledToActId(undefined);
        setScrolledToActIdsArr(undefined);
    }, []);

    const timeoutRef = useTimeout(
        () => {
            resetStates();
        },
        scrolledToActId || scrolledToActIdsArr ? 10000 : null,
    );

    const withHighLightManager = useCallback(
        (closingFn?: () => void) => {
            if (closingFn) {
                closingFn();
                resetStates();
            } else if (timeoutRef?.current) {
                window.clearTimeout(timeoutRef.current);
            }
        },
        [resetStates, timeoutRef],
    );

    return { scrolledToActId, withHighLightManager, scrolledToActIdsArr };
};

export const getActCellClass = (id: number, isOddSeason: boolean, scrolledToActId?: number) => {
    const scrolledTo = Boolean(scrolledToActId) && scrolledToActId === id;

    let cellClass;

    if (scrolledTo) {
        cellClass = 'ag-cell-bg-blue';
    } else {
        cellClass = isOddSeason ? 'oddSeason' : 'evenSeason';
    }

    return cellClass;
};
